import mutations from './mutations';

const state = {
  name: 'CompliSpace',
  version: '0.1.0',
  copyright: '&copy;2018 <strong>Complispace Pty. Ltd.</strong> . All rights reserved.',
  initialised: false,
  contentSearchText: '',
  quickLinksSearchText: '',
  apiVersion: '',
  ceVersion: ''
};

const getters = {
  // @complispace/cs-design-system use this for the app name,
  // changes in here might break in @complispace/cs-design-system for existing idp login
  name: (stateData) => stateData.name,
  version: (stateData) => stateData.version,
  copyright: (stateData) => stateData.copyright
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};
